export const APP_CONFIG = {
  VERSION: '1.0.0',
};

export const datadogConfig = {
  defaultPrivacyLevel: 'mask-user-input',
  DATADOG_EXCLUDE_OPTIMIZELY_ERROR_MSG: "https://a19558781057.cdn.optimizely.com blocked by 'frame-src' directive",
};
